import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import $ from "jquery";

import { homeController } from "../controllers/homeController";

class Home extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    redirectToSignIn: PropTypes.bool.isRequired,
    signedOut: PropTypes.bool.isRequired,
    changePasswordRequired: PropTypes.bool.isRequired,
    shopName: PropTypes.string,
    rewardAmount: PropTypes.number,
    qrCodeSrc: PropTypes.string,
    timer: PropTypes.number,
    loading: PropTypes.bool,
  };

  componentDidMount() {
    this.props.dispatch(homeController.fetchMyInformation());
    this.props.dispatch(homeController.fetchTransientRewardToken());
    this.props.dispatch(homeController.startTimer());
  }

  componentWillUnmount() {
    this.props.dispatch(homeController.stopTimer());
  }

  onClickSignOut = (e) => {
    e.preventDefault();

    $(this.modal).modal("show");
  };

  onClickSignOutInModel = (e) => {
    e.preventDefault();

    $(this.modal).modal("hide");
    this.props.dispatch(homeController.signOut());
  };

  render() {
    if (this.props.redirectToSignIn) {
      window.location.replace("/sign-in/?unauthorized=1");
    } else if (this.props.signedOut) {
      window.location.replace("/sign-in/");
    } else if (this.props.changePasswordRequired) {
      window.location.replace("/change-password/");
    }

    return (
      <>
        <header>
          <nav className="navbar navbar-expand-lg fixed-top navbar-light mt-2 mb-2">
            <div className="container">
              <div className="d-flex ml-auto">
                <button
                  className="btn btn-sm btn-outline-primary"
                  type="submit"
                  onClick={this.onClickSignOut}
                >
                  ログアウト
                </button>
              </div>
            </div>
          </nav>
        </header>
        <div className="ui-full-height-body">
          <div className="container m-auto pb-5">
            <h3 className="text-center display-5 text-break">
              {this.props.shopName}
              <p className="m-3">
                <span className="font-weight-bold">
                  {this.props.rewardAmount}
                </span>{" "}
                <small className="text-muted">ポイント</small>
              </p>
            </h3>
            <div className={`text-center ${this.props.loading && "loading"}`}>
              {this.props.qrCodeSrc ? (
                <img
                  src={this.props.qrCodeSrc}
                  className="img-thumbnail mx-auto d-block"
                  alt="A one-time qr code."
                />
              ) : (
                ""
              )}
              <span className="lead mt-3 d-block text-muted">
                更新 <span className="text-info">{this.props.timer}</span> 秒
              </span>
            </div>
            <div
              className="modal fade"
              ref={(modal) => (this.modal = modal)}
              id="exampleModal"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    ログアウトしてもよろしいですか？
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      閉じる
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={this.onClickSignOutInModel}
                    >
                      ログアウト
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect((state) => {
  const core = state.core || {};
  const apiUnauthorized = core.apiUnauthorized || {};
  const home = state.home || {};

  return {
    redirectToSignIn: !!apiUnauthorized.redirectToSignIn,
    signedOut: !!home.signedOut,
    changePasswordRequired: !!home.changePasswordRequired,
    shopName: home.myInformation ? home.myInformation.name : null,
    rewardAmount: home.myInformation ? home.myInformation.rewardAmount : null,
    qrCodeSrc: home.qrCodeSrc,
    timer: home.timer,
    loading: home.loading,
  };
})(Home);
